import _ from 'underscore';

const ctrl = [
    '$rootScope',
    '$route',
    '$location',
    '$sce',
    'ProductsFactory',
    'ReleasesFactory',
    'UserFactory',
];

class ProductCtrl {
    constructor(
        $rootScope,
        $route,
        $location,
        $sce,
        ProductsFactory,
        ReleasesFactory,
        UserFactory
    ) {
        this.$rootScope = $rootScope;
        this.$route = $route;
        this.$location = $location;
        this.$sce = $sce;
        this.ProductsFactory = ProductsFactory;
        this.ReleasesFactory = ReleasesFactory;
        this.UserFactory = UserFactory;

        this.crumbs = [
            {
                text: 'Products & Editions',
                link: '/',
            },
            {
                text: 'Release List',
            },
        ];

        this.form = {
            inputs: {
                search: {
                    modelValue: '', // Default
                    inUse: '',
                },
            },
        };

        this.hasModern = false;
        this.hasLegacy = false;

        this.filterVal = 'all';

        this.product = {};
        this.releases = [];
        this.toggle = [];

        this.setup();

        this.$rootScope.$on('ProductsFetched', () => this.setup());
        this.$rootScope.$on('ReleasesFetched', () => this.setup());
    }

    _fetchProduct() {
        const staticName = this.$route.current.params.staticName;

        const product = this.ProductsFactory.findByStaticName(staticName);

        return product ? product : {};
    }

    _fetchReleases() {
        return this.ReleasesFactory.getByProduct(this.product.id).map((release) => {
            release.released = this.ReleasesFactory.humanizeDate(release.release_date);

            return release;
        });
    }

    isLoggedIn() {
        return this.UserFactory.isLoggedIn();
    }

    search() {
        let releases = angular.copy(this.getAllReleases());

        releases = this._applySearch(releases);

        this.setSearchedReleases(releases);

        this.setUseSearch(true);

        //this.storeReleaseSearch();
    }

    _searchTermToUse() {
        return this.getModelValueSearchTerm() || this.getUsedSearchTerm();
    }

    _applySearch(releases) {
        let _releases = releases;

        if(!this._searchTermToUse()) {
            return _releases;
        }

        _releases = this.ReleasesFactory.search(this._searchTermToUse(), _releases);

        if(this.getModelValueSearchTerm()) {
            this.setUsedSearchTerm(this.getModelValueSearchTerm());
            //this.setModelValueSearchTerm('');
        }

        _releases.forEach((release) => {
            const property = release.release_notes.toString().toLowerCase();

            if(property && property.includes(this._searchTermToUse().toLowerCase())) {
                this.toggle[release.id] = true;
            } else {
                this.toggle[release.id] = false;
            }
        });

        return _releases;
    }

    resetSearch() {
        this.setModelValueSearchTerm('');
        this.setUsedSearchTerm('');
        this.setUseSearch(false);

        this.search();
    }

    showSearchSummary() {
        return !!this.getUsedSearchTerm();
    }

    getSearchSummary() {
        const searchAttr = this.getUsedSearchTerm();

        if(!searchAttr) {
            return '';
        }

        return `Searching for <strong>${searchAttr}</strong>`;
    }

    toggleLabel(item) {
        return this.toggle[item.id] ? `<i class="fa fa-chevron-up"
            aria-hidden="true"></i> Hide` : `<i class="fa fa-chevron-down"
            aria-hidden="true"></i> View`;
    }

    toggleDetails(item) {
        this.toggle[item.id] = !this.toggle[item.id];
    }

    showDetails(item) {
        return this.toggle[item.id];
    }

    hideReleaseNotes() {
        this.toggle.map(function(value, index, arr) {
            arr[index] = false;
        });
    }

    isReleaseNotesOpen() {
        return this.toggle.find(function(item) {
            return item;
        });
    }

    showLegacy(item) {
        return item.is_gated && item.product.vendor === 'ia' && item.product.class !== 'msi';
    }

    getList() {
        let releases = this.getAllReleases();

        if(!releases) {
            return;
        }

        releases.map((release) => {
            release.product = this.ProductsFactory.findById(release.product_id);
        });

        this.hasLegacy = releases.find(function(item) {
            return item.is_gated && item.product.vendor === 'ia' && item.product.class !== 'msi';
        });

        this.hasModern = releases.find(function(item) {
            return !(item.is_gated && item.product.vendor === 'ia' && item.product.class !== 'msi');
        });

        if(this.useSearch()) {
            releases = this.getSearchedReleases();
        }

        releases = _.sortBy(releases, 'release_date').reverse();

        if(this.filterVal === 'all') {
            return releases;
        }

        return releases.filter((release) => {
            if(this.showLegacy(release) && this.filterVal === 'legacy') {
                return true;
            }

            if(!this.showLegacy(release) && this.filterVal === 'modern') {
                return true;
            }

            return false;
        });
    }

    getAllReleases() {
        return this.releases.all;
    }

    getSearchedReleases() {
        return this.releases.searched;
    }

    getModelValueSearchTerm() {
        return this.form.inputs.search.modelValue;
    }

    getUsedSearchTerm() {
        return this.form.inputs.search.inUse;
    }

    useSearch() {
        return this.releases.useSearch;
    }

    setUsedSearchTerm(searchVal) {
        this.form.inputs.search.inUse = searchVal;
    }

    setModelValueSearchTerm(searchVal) {
        this.form.inputs.search.modelValue = searchVal;
    }

    setSearchedReleases(releases) {
        this.releases.searched = releases;
    }

    setAllReleases(releases) {
        this.releases.all = releases;
    }

    setUseSearch(x) {
        this.releases.useSearch = x;
    }

    highlight(text, search) {
        if(!search) {
            return this.$sce.trustAsHtml(text);
        }
        return this.$sce.trustAsHtml(text.replace(new RegExp(search, 'gi'), '<span class="highlightedText">$&</span>'));
    }

    filterButtonClass(filterVal) {
        if(this.filterVal === filterVal) {
            return 'tag is-primary';
        }
        return 'tag';
    }

    setFilter(filterVal) {
        this.filterVal = filterVal;
    }

    hasGuideLink(item) {
        return !!item.guide_link;
    }

    download(id, file) {
        return this.isLoggedIn() ? this.downloadLoggedIn(id, file) : this.downloadNotLoggedIn(id, file);
    }

    downloadLoggedIn(id, file) {
        return `/api/download/release/${id}/${file}`;
    }

    downloadNotLoggedIn(id, file) {
        return `/api/public/download/release/${id}/${file}`;
    }

    product() {
        return this.product;
    }

    moreInfo(id) {
        this.$location.path(`/release/${id}`);
    }

    back() {
        this.$location.path('/');
    }

    setup() {
        this.product = this._fetchProduct();

        if(!Object.keys(this.product).length) {
            return;
        }

        this.releases = this._fetchReleases(this.product.id);
        this.setAllReleases(this.releases);
    }
}

ctrl.push(ProductCtrl);

export default ctrl;



// WEBPACK FOOTER //
// ./resources/assets/app-releases/controllers/ProductCtrl.js